(() => {
  const enhance = (root) => {
    root.querySelectorAll('details[data-fv-fold-after-load]').forEach((details) => {
      if (details.dataset.fvDisclosureReady) return;
      details.dataset.fvDisclosureReady = 'true';
      details.open = false;
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhance(document), { once: true });
  } else {
    enhance(document);
  }
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
